<i18n>
{
  "en": {
    "title": "Integrated Sustainability 2017-2018",
    "description": "At Schneider Electric, sustainability guides our operations, performance, and decision making, as we look to make a positive change in green energy and the environment. Learn how sustainability guides our business, from strategy to communications.",
    "lookingAhead": {
      "section": "Looking Ahead",
      "title": "An Integrated Approach to Sustainability",
      "sustainability": {
        "txt1": {
          "p1": "At Schneider Electric, sustainability is business. It’s at the heart of operations, performance, decision making, and strategy."
        },
        "table1": {
          "txt": {
            "title": "Sustainability means company growth"
          },
          "row1": {
            "cell1": {
              "title": "Sustainability is business"
            },
            "cell2": {
              "p1": "The vision of Schneider Electric, the global specialist in energy management and automation, is to ensure that Life Is On&trade; for everyone, everywhere, and at every moment, and help our customers achieve more with less."
            }
          },
          "row2": {
            "cell1": {
              "title": "Sustainability strategy to meet the energy challenge"
            },
            "cell2": {
              "p1": "Act to keep global warming below a 2 °C limit and to reduce the energy gap, with ethics and responsibility."
            }
          }
        },
        "table2": {
          "txt": {
            "title": "At the strategic level: integrated into the company program"
          },
          "row1": {
            "cell1": {
              "title": "Sustainability in the initiative “Innovate to support growth”"
            },
            "cell2": {
              "title": "<strong>Objective:</strong>",
              "p1": "Be a partner of choice in sustainability in our innovations and our operations."
            }
          },
          "row2": {
            "cell1": {
              "title": "5 sustainability megatrends 2015 – 2020"
            },
            "cell2": {
              "li1": "Climate",
              "li2": "Circular Economy",
              "li3": "Development",
              "li4": "Ethics",
              "li5": "Health &amp; Equity"
            }
          },
          "row3": {
            "cell1": {
              "title": "21 sustainability progress indicators 2018 – 2020"
            },
            "cell2": {
              "p1": "Schneider Sustainability Impact target is a level for progress and accountability."
            }
          }
        },
        "table3": {
          "txt": {
            "title": "At the communication level: integrated and reliable processes"
          },
          "row1": {
            "cell1": {
              "title": "The Schneider Sustainability Impact, commented on by the CFO and the CEO"
            },
            "cell2": {
              "p1": "Non-financial quarterly results are presented together with financial information to institutional investors."
            }
          },
          "row2": {
            "cell1": {
              "title": "Audited non-financial results"
            },
            "cell2": {
              "p1": "Non-financial information, including barometer’s indicators, receive moderate or reasonable assurance."
            }
          }
        },
        "table4": {
          "txt": {
            "title": "At the operational level: integrated governance involving every level"
          },
          "row1": {
            "cell1": {
              "title": "Board of directors"
            },
            "cell2": {
              "p1": "The HR &amp; CSR Committee approves the sustainability strategy, and analyzes policies and practices."
            }
          },
          "row2": {
            "cell1": {
              "title": "Executive committee"
            },
            "cell2": {
              "p1": "The sustainability executive committee challenges, aligns with strategy, and decides."
            }
          },
          "row3": {
            "cell1": {
              "title": "Corporate functions and businesses, specific committees, employees"
            },
            "cell2": {
              "p1": "These bodies contribute to sustainability objectives (Schneider Sustainability Impact target, CSR criteria in variable compensation) and mobilization programs."
            }
          }
        }
      }
    }
  },
  "fr": {
    "title": "Integrated Sustainability 2017-2018",
    "description": "At Schneider Electric, sustainability guides our operations, performance, and decision making, as we look to make a positive change in green energy and the environment. Learn how sustainability guides our business, from strategy to communications.",
    "lookingAhead": {
      "section": "Anticiper demain",
      "title": "Une démarche de développement durable intégrée",
      "sustainability": {
        "txt1": {
          "p1": "Chez Schneider Electric, le développement durable est indissociable du développement économique. Il est au cœur de nos opérations, de notre performance, de nos processus de décision et de notre stratégie."
        },
        "table1": {
          "txt": {
            "title": "Le développement durable, synonyme de croissance"
          },
          "row1": {
            "cell1": {
              "title": "Développement durable et développement économique vont de pair"
            },
            "cell2": {
              "p1": "La vision de Schneider Electric, spécialiste mondial de la gestion de l’énergie et des automatismes, est de faire en sorte que la vie s’illumine (Life is On) partout, pour tous, à chaque instant, et d'aider nos clients à accomplir plus avec moins."
            }
          },
          "row2": {
            "cell1": {
              "title": "Stratégie de développement durable pour relever le défi énergétique"
            },
            "cell2": {
              "p1": "Nous agissons pour maintenir le réchauffement climatique sous une  limite de 2 °C et pour réduire la fracture énergétique avec éthique et responsabilité."
            }
          }
        },
        "table2": {
          "txt": {
            "title": "Au niveau stratégique : intégration dans le programme d’entreprise"
          },
          "row1": {
            "cell1": {
              "title": "Le développement durable dans l’initiative « Innover pour accompagner la croissance »"
            },
            "cell2": {
              "title": "<strong>Objectif :</strong>",
              "p1": "être un partenaire de choix dans le développement durable grâce à nos innovations et à nos opérations."
            }
          },
          "row2": {
            "cell1": {
              "title": "Nos cinq défis clés pour le développement durable"
            },
            "cell2": {
              "li1": "Climat",
              "li2": "Économie circulaire",
              "li3": "Santé & équité",
              "li4": "Éthique",
              "li5": "Développement"
            }
          },
          "row3": {
            "cell1": {
              "title": "21 plans de progrès développement durable sur la période 2018 – 2020 :"
            },
            "cell2": {
              "p1": "Le baromètre Schneider Sustainability Impact mesure notre avancement et engage notre responsabilité."
            }
          }
        },
        "table3": {
          "txt": {
            "title": "Au niveau de la communication : des processus fiables et intégrés"
          },
          "row1": {
            "cell1": {
              "title": "Le baromètre Schneider Sustainability Impact, commenté par le Directeur financier et le Président Directeur général"
            },
            "cell2": {
              "p1": "Les résultats extra-financiers trimestriels sont présentés en même temps que les informations financières aux investisseurs institutionnels."
            }
          },
          "row2": {
            "cell1": {
              "title": "Des résultats extra-financiers audités"
            },
            "cell2": {
              "p1": "Les informations extra-financières, y compris les indicateurs du baromètre Schneider Sustainability Impact, recoivent une assurance  modérée ou raisonnable."
            }
          }
        },
        "table4": {
          "txt": {
            "title": "Au niveau opérationnel : une gouvernance intégrée impliquant chaque échelon"
          },
          "row1": {
            "cell1": {
              "title": "Conseil d'administration"
            },
            "cell2": {
              "p1": "Le comité RH & RSE approuve la stratégie de développement durable et analyse les politiques et les pratiques en la matière."
            }
          },
          "row2": {
            "cell1": {
              "title": "Comité exécutif"
            },
            "cell2": {
              "p1": "Le comité exécutif de développement durable challenge, aligne avec la stratégie et décide. "
            }
          },
          "row3": {
            "cell1": {
              "title": "Fonctions centrales et activités,  comités spécifiques, collaborateurs"
            },
            "cell2": {
              "p1": "Ils contribuent aux Objectifs de Développement Durable (baromètre Schneider Sustainability Impact, critères RSE dans les  rémunérations variables) et aux programmes de mobilisation."
            }
          }
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('@/assets/img/looking-ahead/looking-ahead-integrated-approach-hero-lores.jpg')" :hiResSrc="require('@/assets/img/looking-ahead/looking-ahead-integrated-approach-hero.jpg')" chapter="07" :section="$t('lookingAhead.section')" :title="$t('lookingAhead.title')" :grayBG="true" />

    <section class="m-t-120 m-b-120">
      <Statement>
        <h3 v-html="$t('lookingAhead.sustainability.txt1.p1')"></h3>
      </Statement>
    </section>

    <section class="l-bg-white l-section-pad m-b-120">
      <TxtMedia class="m-b-80" columns="2">
        <div slot="main-content">
          <h2 id="sustainablegrowth" v-html="$t('lookingAhead.sustainability.table1.txt.title')"></h2>
          <h3 class="" v-html="$t('lookingAhead.sustainability.table1.row1.cell1.title')"></h3>
          <p class="" v-html="$t('lookingAhead.sustainability.table1.row1.cell2.p1')"></p>
          <h3 class="" v-html="$t('lookingAhead.sustainability.table1.row2.cell1.title')"></h3>
          <p class="" v-html="$t('lookingAhead.sustainability.table1.row2.cell2.p1')"></p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/looking-ahead/GettyImages-931007142_a.jpg')" alt="">
      </TxtMedia>

      <Table class="m-b-80" columns="2">
        <h2 slot="above" v-html="$t('lookingAhead.sustainability.table2.txt.title')"></h2>
        <TableRow>
          <TableCell :bgimg="require('@/assets/img/looking-ahead/GettyImages-476387962.jpg')">
            <h3 class="t-white" v-html="$t('lookingAhead.sustainability.table2.row1.cell1.title')"></h3>
          </TableCell>
          <TableCell>
            <p class="t-chartbody" v-html="$t('lookingAhead.sustainability.table2.row1.cell2.title')"></p>
            <p class="t-chartbody" v-html="$t('lookingAhead.sustainability.table2.row1.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <h3 class="t-green-light" v-html="$t('lookingAhead.sustainability.table2.row2.cell1.title')"></h3>
          </TableCell>
          <TableCell bgc="#3dcd58">
            <ul>
              <li class="t-white" v-html="$t('lookingAhead.sustainability.table2.row2.cell2.li1')"></li>
              <li class="t-white" v-html="$t('lookingAhead.sustainability.table2.row2.cell2.li2')"></li>
              <li class="t-white" v-html="$t('lookingAhead.sustainability.table2.row2.cell2.li3')"></li>
              <li class="t-white" v-html="$t('lookingAhead.sustainability.table2.row2.cell2.li4')"></li>
              <li class="t-white" v-html="$t('lookingAhead.sustainability.table2.row2.cell2.li5')"></li>
            </ul>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell :bgimg="require('@/assets/img/looking-ahead/Water-of-the-Sun4.jpg')">
            <h3 class="t-white" v-html="$t('lookingAhead.sustainability.table2.row3.cell1.title')"></h3>
          </TableCell>
          <TableCell>
            <p class="t-chartbody" v-html="$t('lookingAhead.sustainability.table2.row3.cell2.p1')"></p>
          </TableCell>
        </TableRow>
      </table>

      <TxtMedia class="m-b-80" columns="2">
        <div slot="main-content">
          <h2 v-html="$t('lookingAhead.sustainability.table3.txt.title')"></h2>
          <h3 class="" v-html="$t('lookingAhead.sustainability.table3.row1.cell1.title')"></h3>
          <p class="" v-html="$t('lookingAhead.sustainability.table3.row1.cell2.p1')"></p>
          <h3 class="" v-html="$t('lookingAhead.sustainability.table3.row2.cell1.title')"></h3>
          <p class="" v-html="$t('lookingAhead.sustainability.table3.row2.cell2.p1')"></p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/looking-ahead/551986579_RGB.jpg')" alt="">
      </TxtMedia>

      <Table class="" columns="2">
        <h2 slot="above" v-html="$t('lookingAhead.sustainability.table4.txt.title')"></h2>
        <TableRow>
          <TableCell :bgimg="require('@/assets/img/looking-ahead/GettyImages-530055153.jpg')">
            <h3 class="t-white" v-html="$t('lookingAhead.sustainability.table4.row1.cell1.title')"></h3>
          </TableCell>
          <TableCell>
            <p class="t-chartbody" v-html="$t('lookingAhead.sustainability.table4.row1.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <h3 class="t-green-light" v-html="$t('lookingAhead.sustainability.table4.row2.cell1.title')"></h3>
          </TableCell>
          <TableCell class="t-white" bgc="#3dcd58">
            <p class="t-chartbody" v-html="$t('lookingAhead.sustainability.table4.row2.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell :bgimg="require('@/assets/img/looking-ahead/GettyImages-537266160.jpg')">
            <h3 class="t-white" v-html="$t('lookingAhead.sustainability.table4.row3.cell1.title')"></h3>
          </TableCell>
          <TableCell>
            <p class="t-chartbody" v-html="$t('lookingAhead.sustainability.table4.row3.cell2.p1')"></p>
          </TableCell>
        </TableRow>
      </table>
    </section>

   <div class="l-content">
      <FooterNav
        prevRoute="LookingAhead_2018Priorities"
        nextRoute="LookingAhead_About" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import References from '@/components/References'
import Reference from '@/components/Reference'
import YouTubeVideo from '@/components/YouTubeVideo'
import ImageFull from '@/components/ImageFull'
import Table from '@/components/Table'
import TableRow from '@/components/TableRow'
import TableCell from '@/components/TableCell'
import TxtMedia from '@/components/TxtMedia'

export default {
  name: 'LookingAhead_SustainabilityApproach',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    References,
    Reference,
    YouTubeVideo,
    ImageFull,
    Table,
    TableRow,
    TableCell,
    TxtMedia
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/looking-ahead/sustainability-approach.vue